import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  addCategory,
  updateCategory,
  getCategoryById,
} from "../../services/categoryService"; // ✅ Your API service file
import SuccessAlert from "../../components/child/Alert/SuccessAlert";
import DengerAlert from "../../components/child/Alert/DengerAlert";
import Loader from "../../components/child/Loder";

const CategoryFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // for edit mode
  const isEditMode = !!id;

  const [name, setName] = useState("");
  const [type, setType] = useState(""); // ✅ NEW state for type
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [errors, setErrors] = useState({});

  // ✅ Fetch category for edit mode
  useEffect(() => {
    if (isEditMode) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const res = await getCategoryById(id);
          const { data } = res.data;
          setName(data.name || "");
          setType(data.type || ""); // ✅ pre-fill type
        } catch (err) {
          setErrorMessage("Failed to fetch category.");
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [id]);

  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };

  const validateInputs = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Category name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(name.trim())) {
      newErrors.name = "Only alphabets and spaces are allowed.";
    }
    // ✅ validation for type
    if (!type) {
      newErrors.type = "Category type is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      let response;

      if (isEditMode) {
        response = await updateCategory(id, { name, type });
      } else {
        response = await addCategory({ name, type });
      }
      const successMsg =
        response?.data?.message ||
        response?.data?.data?.message ||
        (isEditMode
          ? "Category updated successfully!"
          : "Category added successfully!");

      setSuccessMessage(successMsg);
      setTimeout(() => {
        navigate("/categories");
      }, 1000);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        (isEditMode ? "Failed to update category." : "Failed to add category.");
      setErrorMessage(msg);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DengerAlert message={errorMessage} />}
            <form
              className="row gy-3 needs-validation"
              noValidate
              onSubmit={handleSubmit}
            >
              <div className="col-md-12">
                <label className="form-label">
                  Category Name<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter category name"
                  value={name}
                  maxLength={50}
                  onChange={(e) => {
                    const val = e.target.value;

                    // Allow only alphabets and single spaces
                    const filtered = val
                      .replace(/[^A-Za-z\s]/g, "")
                      .replace(/\s{2,}/g, " ");
                    setName(filtered);
                    setErrors((prev) => ({ ...prev, name: "" }));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                      .trimStart(); // Prevent leading spaces
                  }}
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>

              {/* ✅ Type field (dropdown) */}
              <div className="col-md-12">
                <label className="form-label">
                  Category Type<span className="text-danger-600">*</span>
                </label>
                <select
                  className={`form-select ${errors.type ? "is-invalid" : ""}`}
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                    setErrors((prev) => ({ ...prev, type: "" }));
                  }}
                >
                  <option value="">Select Type</option>
                  <option value="booth">Booth</option>
                  <option value="ticket">Ticket</option>
                </select>
                {errors.type && (
                  <div className="invalid-feedback">{errors.type}</div>
                )}
              </div>

              <div className="col-12">
                <button
                  className="btn btn-primary float-end"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Saving..." : isEditMode ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryFormPage;
